// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import * as XLSX from "xlsx";
// import useApi from "../../../CustomHooks/useApi";
// import DynamicTable from "../../../ResuableCompoment/DynamicTable";
// import { getDisplayDate } from "../../../ResuableCompoment/GetDisplayDate";

// /* ================= HELPERS ================= */
// // const getToday = () => new Date().toISOString().split("T")[0];
// const getToday = () => {
//   const date = new Date();
//   const yyyy = date.getFullYear();
//   const mm = String(date.getMonth() + 1).padStart(2, "0");
//   const dd = String(date.getDate()).padStart(2, "0");
//   return `${yyyy}-${mm}-${dd}`;
// };

// const FILTER_BUTTONS = [
//   { label: "Account Statement", value: "ACCOUNT" }, // special
//   { label: "DMT", value: "DMT" },
//   { label: "AEPS", value: "AEPS" },
//   { label: "PPI", value: "PPI" },
//   { label: "CMS", value: "CMS" },
//   { label: "SETTLEMENT", value: "SETTLEMENT" },
//   { label: "RECHARGE", value: "RECHARGE" },
//   { label: "CREDIT CARD BILL PAYMENT", value: "CCBP" },
//   { label: "FUND (CREDIT / DEBIT)", value: "BZCIN" },
//   { label: "BENE VERIFICATION", value: "BENE" },
//   { label: "RETAILER FUND REQUEST", value: "FUND_REQUEST" },
//   { label: "PG", value: "PG" },
//   { label: "SUBSCRIPTION", value: "SUBSCRIPTION" },
//   { label: "OVER DRAFT", value: "OD" },
// ];

// /* ================= COLUMNS ================= */
// const columns = [
//   {
//     key: "txnId",
//     label: "Txn ID",
//   },
//   {
//     key: "txnDate",
//     label: "Date",
//     render: (v) => getDisplayDate(v),
//   },
//   {
//     key: "narration",
//     label: "Narration",
//     render: (v) => (
//       <span className="text-indigo-700 font-medium">
//         {v || "—"}
//       </span>
//     ),
//   },
//   /* ================= AMOUNT SPLIT ================= */

//   {
//     key: "amount_cr",
//     label: "Amount (CR)",
//     render: (_, row) => {
//       if (row.txnType === "REJECTED") {
//         return (
//           <span className="font-semibold text-red-600">
//             ₹{Number(row.netAmount || 0).toFixed(2)}
//           </span>
//         );
//       }

//       if (row.txnType === "CREDIT" || row.txnType === "APPROVED" || row.txnType === "REFUND") {
//         return (
//           <span className="font-semibold text-green-700">
//             ₹{Number(row.netAmount || 0).toFixed(2)}
//           </span>
//         );
//       }

//       return <span className="text-gray-400">—</span>;
//     },
//   },

//   {
//     key: "amount_dr",
//     label: "Amount (DR)",
//     render: (_, row) =>
//       (row.txnType === "DEBIT" || row.txnType === "REVERSED") ? (
//         <span className="font-semibold text-red-600">
//           ₹{Number(row.netAmount || 0).toFixed(2)}
//         </span>
//       ) : (
//         <span className="text-gray-400">—</span>
//       ),
//   },

//   /* ================= OTHER AMOUNTS (NO COLOR) ================= */

//   {
//     key: "charges",
//     label: "Charge",
//     render: (v) => (
//       <span className="font-semibold text-red-700">
//         ₹{Number(v || 0).toFixed(2)}
//       </span>
//     ),
//   },

//   {
//     key: "tds",
//     label: "TDS",
//     render: (v) => (
//       <span className="font-semibold text-red-800">
//         ₹{Number(v || 0).toFixed(2)}
//       </span>
//     ),
//   },
//   /* ================= NET AMOUNT (COLOR LOGIC) ================= */

//   {
//     key: "txnAmount",
//     label: "Net Amount",
//     render: (v, row) => {
//       const value = Number(v || 0);
//       if (!row || !value) return <span className="text-gray-400">—</span>;
//       if (row.txnType === "CREDIT" || row.txnType === "APPROVED" || row.txnType === "REJECTED" || row.txnType === "REFUND") {
//         return (
//           <span className="font-semibold text-green-700">
//             ₹{value.toFixed(2)}
//           </span>
//         );
//       }

//       if (row.txnType === "DEBIT" || row.txnType === "REVERSED") {
//         return (
//           <span className="font-semibold text-red-600">
//             ₹{value.toFixed(2)}
//           </span>
//         );
//       }

//       return <span className="text-gray-400">—</span>;
//     },
//   },

//   {
//     key: "commission",
//     label: "Comm",
//     render: (_, row) => {
//       const value = Number(row.cashback || row.commission || 0);

//       return (
//         <span className="font-bold text-green-800">
//           ₹{value.toFixed(2)}
//         </span>
//       )
//     },
//   },
//   {
//     key: "balance",
//     label: "Balance",
//     render: (v) => (
//       <span className="font-semibold text-blue-900">
//         ₹{Number(v || 0).toFixed(2)}
//       </span>
//     ),
//   },
// ];
// const SummaryCard = ({
//   title,
//   value,
//   isCurrency = true,
// }) => {
//   const formattedValue =
//     typeof value === "number"
//       ? value.toLocaleString("en-IN", {
//         minimumFractionDigits: isCurrency ? 2 : 0,
//         maximumFractionDigits: isCurrency ? 2 : 0,
//       })
//       : value;

//   return (
//     <div
//       className="
//         p-6 rounded-2xl
//         bg-[#0A2A4F]                 /* dark blue */
//         border border-blue-400/30
//         shadow-lg
//         transition-all duration-300
//         hover:scale-[1.03]
//         hover:shadow-[0_0_22px_rgba(59,130,246,0.35)]
//         flex flex-col justify-between
//       "
//     >
//       {/* TITLE */}
//       <div className="text-white">
//         {title}
//       </div>

//       {/* VALUE */}
//       <div className="mt-4">
//         <p className="text-white font-extrabold text-2xl sm:text-3xl leading-tight break-words">
//           {isCurrency ? "₹" : ""}
//           {formattedValue}
//         </p>
//       </div>
//     </div>
//   );
// };

// const LedgerReport = () => {
//   const mid = useSelector(state => state.auth.employeeDetails?.username);

//   const { callApi: ledgerreport } = useApi(
//     "/ledger/retailer",
//     "GET"
//   );

//   /* ================= STATES ================= */
//   const [history, setHistory] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   const [page, setPage] = useState(0);
//   const [size, setSize] = useState(25);
//   const [totalPages, setTotalPages] = useState(0);
//   const [totalElements, setTotalElements] = useState(0);
//   const [goToPage, setGoToPage] = useState("");
//   const [filterType, setFilterType] = useState("ACCOUNT");

//   /* ================= FETCH LEDGER ================= */
//   const fetchLedger = async (
//     targetPage = 0,
//     loadMore = false,
//     fDate = fromDate,
//     tDate = toDate,
//     fType = filterType
//   ) => {
//     setLoading(true);

//     let query = `?bid=${mid}&page=${targetPage}&size=${size}`;
//     if (fDate) query += `&fromDate=${fDate}`;
//     if (tDate) query += `&toDate=${tDate}`;

//     // 🔥 IMPORTANT LOGIC
//     if (fType && fType !== "ACCOUNT") {
//       query += `&feature=${fType}`;
//     }

//     try {
//       const res = await ledgerreport(null, query);
//       const data = (res?.content || []).filter(Boolean);

//       setTotalPages(res?.totalPages || 0);
//       setTotalElements(res?.totalElements || 0);

//       setHistory(prev =>
//         loadMore ? [...prev, ...data] : data
//       );

//       setPage(targetPage);
//     } catch (err) {
//       console.error(err);
//       if (!loadMore) setHistory([]);
//     } finally {
//       setLoading(false);
//     }
//   };


//   /* ================= INITIAL LOAD (TODAY) ================= */
//   useEffect(() => {
//     const today = getToday();
//     setFromDate(today);
//     setToDate(today);
//     fetchLedger(0, false, today, today);
//     // eslint-disable-next-line
//   }, []);

//   /* ================= PAGE SIZE CHANGE ================= */
//   useEffect(() => {
//     if (fromDate && toDate) {
//       fetchLedger(0, false, fromDate, toDate);
//     }
//     // eslint-disable-next-line
//   }, [size]);

//   useEffect(() => {
//     const today = getToday();
//     setFromDate(today);
//     setToDate(today);
//     fetchLedger(0, false, today, today, "ACCOUNT");
//     // eslint-disable-next-line
//   }, []);


//   /* ================= SEARCH ================= */
//   const handleSearch = () => {
//     fetchLedger(0, false, fromDate, toDate, filterType);
//   };


//   const handleFilterClick = (type) => {
//     setFilterType(type);
//     setHistory([]);
//     setPage(0);
//     fetchLedger(0, false, fromDate, toDate, type);
//   };


//   /* ================= GO TO PAGE ================= */
//   const handleGoToPage = () => {
//     const p = Number(goToPage);
//     if (p < 1 || p > totalPages) {
//       alert(`Enter page between 1 and ${totalPages}`);
//       return;
//     }
//     fetchLedger(p - 1, false, fromDate, toDate);
//   };

//   /* ================= LOAD MORE ================= */
//   const handleLoadMore = () => {
//     if (page + 1 < totalPages) {
//       fetchLedger(page + 1, true, fromDate, toDate);
//     }
//   };

//   /* ================= EXCEL DOWNLOAD (SIZE = 10000) ================= */
//   const downloadExcel = async () => {
//     setLoading(true);

//     let allData = [];
//     let currentPage = 0;
//     const excelSize = 1000; // safe for backend

//     try {
//       while (true) {
//         let query = `?bid=${mid}&page=${currentPage}&size=${excelSize}`;

//         if (fromDate) query += `&fromDate=${fromDate}`;
//         if (toDate) query += `&toDate=${toDate}`;

//         // 🔥 SAME FILTER AS UI
//         if (filterType && filterType !== "ACCOUNT") {
//           query += `&feature=${filterType}`;
//         }

//         const res = await ledgerreport(null, query);

//         const pageData = (res?.content || []).filter(Boolean);

//         allData = [...allData, ...pageData];

//         if (currentPage + 1 >= (res?.totalPages || 0)) break;
//         currentPage++;
//       }

//       if (allData.length === 0) {
//         alert("No data found for Excel");
//         return;
//       }

//       /* ================= FORMAT EXCEL ROWS ================= */
//       const rows = allData.map(r => ({
//         Date: getDisplayDate(r.txnDate),
//         TxnID: r.txnId,
//         Shop: r.shopName,
//         Narration: r.narration,
//         Type: r.txnType,

//         Credit:
//           r.txnType === "CREDIT" || r.txnType === "APPROVED" || r.txnType === "REJECTED"
//             ? r.txnAmount
//             : "",
//         Debit:
//           r.txnType === "DEBIT" || r.txnType === "REVERSED"
//             ? r.netAmount
//             : "",

//         Refund:
//           r.txnType === "REFUND"
//             ? r.txnAmount
//             : "",

//         Charge: r.charges,
//         Cashback: r.cashback,
//         Commission: r.commission,
//         TDS: r.tds,
//         Balance: r.balance,
//       }));

//       const ws = XLSX.utils.json_to_sheet(rows);
//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws, "Ledger");

//       XLSX.writeFile(
//         wb,
//         `Ledger_${filterType}_${fromDate}_to_${toDate}.xlsx`
//       );
//     } catch (err) {
//       console.error(err);
//       alert("Excel download failed");
//     } finally {
//       setLoading(false);
//     }
//   };


//   /* ================= TOTAL CALCULATIONS ================= */
//   const totalCR = history.reduce(
//     (sum, tx) =>
//       (tx?.txnType === "CREDIT" || tx?.txnType === "APPROVED" || tx.txnType === "REJECTED")
//         ? sum + Number(tx?.netAmount || 0)
//         : sum,
//     0
//   );

//   const totalDR = history.reduce(
//     (sum, tx) =>
//       (tx?.txnType === "DEBIT" || tx.txnType === "REVERSED")
//         ? sum + Number(tx?.netAmount || 0)
//         : sum,
//     0
//   );


//   const totalNetAmount = history.reduce(
//     (sum, tx) => sum + Number(tx?.txnAmount || 0),
//     0
//   );


//   const totalCharges = history.reduce(
//     (sum, tx) => sum + Number(tx?.charges || 0),
//     0
//   );

//   const totalTds = history.reduce(
//     (sum, tx) => sum + Number(tx?.tds || 0),
//     0
//   );

//   const totalCommission = history.reduce(
//     (sum, tx) => sum + Number(tx?.commission || 0),
//     0
//   );


//   return (
//     <div className="min-h-screen">

//       {/* ================= PAGE TITLE ================= */}
//       <div className="mb-6">
//         <h1 className="text-3xl font-bold text-[#0A2A4F]">
//           Ledger Report
//         </h1>
//         <p className="text-sm text-gray-600 mt-1">
//           Complete transaction history with detailed breakup
//         </p>
//       </div>

//       {/* ================= SUMMARY CARDS ================= */}
//       {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 mb-10">
//         <SummaryCard
//           title={
//             <>
//               <span className="text-lg font-semibold">Total Records</span>
//               <span className="block text-sm font-bold mt-1">
//                 कुल रिकॉर्ड
//               </span>
//             </>
//           }
//           value={totalElements}
//           isCurrency={false}
//         />
//         <SummaryCard
//           title={
//             <>
//               <span className="text-lg font-semibold">Total Credit</span>
//               <span className="block text-sm font-bold mt-1">
//                 जो आपके खाते में आया है
//               </span>
//             </>
//           }
//           value={totalCR}
//         />
//         <SummaryCard
//           title={
//             <>
//               <span className="text-lg font-semibold">Total Debit</span>
//               <span className="block text-sm font-bold mt-1">
//                 जो ग्राहक के खाते में गया है
//               </span>
//             </>
//           }
//           value={totalDR}
//         />
//         <SummaryCard
//           title={
//             <>
//               <span className="text-lg font-semibold">Net Amount</span>
//               <span className="block text-sm font-bold mt-1">
//                 आपके खाते में आए हुए पैसे, आपके खाते से कटे हुए पैसे और लगाए गए चार्ज — इन सभी का कुल जोड़।
//               </span>
//             </>
//           }
//           value={totalNetAmount}
//         />

//       </div> */}





//       {/* ================= INFO NOTE ================= */}
//       {/* <div className="mb-6 bg-blue-50 border border-blue-200 rounded-xl p-5 text-sm text-slate-700">
//         <p className="font-semibold text-blue-800 mb-2">
//           ℹ️ Total & Excel Calculation Info
//         </p>

//         <p className="leading-relaxed">
//           <b>English:</b> Totals are calculated only from currently loaded
//           records. Clicking <b>Load More</b> updates totals automatically.
//           Excel download always includes the full selected date range.
//         </p>

//         <p className="mt-3 leading-relaxed">
//           <b>हिंदी:</b> कुल राशि केवल लोड किए गए रिकॉर्ड से निकाली जाती है।
//           <b> Load More</b> पर नए रिकॉर्ड जुड़ते हैं और कुल अपने आप अपडेट होता है।
//           Excel में चुनी गई तारीख की पूरी रिपोर्ट आती है।
//         </p>
//       </div> */}

//       {/* ================= FILTER BUTTONS ================= */}
//       <div className="flex flex-wrap gap-3 mb-6">
//         {FILTER_BUTTONS.map(btn => (
//           <button
//             key={btn.value}
//             onClick={() => handleFilterClick(btn.value)}
//             className={`
//             px-6 py-3 rounded-xl border text-sm font-semibold
//             transition-all duration-300
//             ${filterType === btn.value
//                 ? "bg-[#0A2A4F] text-white shadow-lg scale-105"
//                 : "bg-white text-[#0A2A4F] border-gray-300 hover:bg-slate-100"}
//           `}
//           >
//             {btn.label}
//           </button>
//         ))}
//       </div>

//       {/* ================= FILTER BAR ================= */}
//       <div className="bg-white rounded-2xl shadow-sm border p-6 mb-8">
//         <div className="flex flex-wrap items-end gap-6">
//           <div>
//             <label className="text-xs text-gray-500">From Date</label>
//             <input
//               type="date"
//               value={fromDate}
//               onChange={e => setFromDate(e.target.value)}
//               className="h-11 w-44 rounded-lg border px-3 mt-1"
//             />
//           </div>

//           <div>
//             <label className="text-xs text-gray-500">To Date</label>
//             <input
//               type="date"
//               value={toDate}
//               onChange={e => setToDate(e.target.value)}
//               className="h-11 w-44 rounded-lg border px-3 mt-1"
//             />
//           </div>

//           <button
//             onClick={handleSearch}
//             className="h-11 px-8 rounded-full bg-[#0A2A4F] text-white font-semibold shadow-md hover:bg-[#08305F]"
//           >
//             Search
//           </button>

//           <button
//             onClick={downloadExcel}
//             disabled={loading}
//             className="h-11 px-8 rounded-full bg-green-700 text-white
//              font-semibold shadow-md hover:bg-green-800
//              disabled:opacity-50"
//           >
//             {loading ? "Preparing Excel..." : "Export Full Ledger"}
//           </button>

//         </div>

//         {/* PAGINATION INFO */}
//         <div className="mt-6 flex flex-wrap items-center gap-6 text-sm text-gray-600">
//           <span><b>Total Records:</b> {totalElements}</span>
//           <span><b>Pages:</b> {totalPages}</span>
//           <span><b>Current Page:</b> {page + 1}</span>

//           <div className="flex items-center gap-2 ml-auto">
//             <input
//               type="number"
//               placeholder="Go to page"
//               value={goToPage}
//               onChange={e => setGoToPage(e.target.value)}
//               className="h-9 w-24 rounded-lg border px-2"
//             />
//             <button
//               onClick={handleGoToPage}
//               className="h-9 px-4 rounded-lg bg-indigo-600 text-white"
//             >
//               Go
//             </button>
//           </div>

//           <select
//             value={size}
//             onChange={e => setSize(Number(e.target.value))}
//             className="h-9 rounded-lg border px-2"
//           >
//             <option value={50}>50</option>
//             <option value={100}>100</option>
//             <option value={500}>500</option>
//             <option value={1000}>1000</option>
//             <option value={2000}>2000</option>
//           </select>
//         </div>
//       </div>

//       {/* ================= TABLE ================= */}
//       <div>
//         <DynamicTable
//           columns={columns}
//           data={history}
//           isLoading={loading}
//           emptyText="No ledger records found"
//           rowClassName={(row) => {
//             if (row.txnType === "DEBIT" || row.txnType === "REVERSED") {
//               return "bg-red-100"; // 🔴 Darker Debit
//             }

//             if (row.txnType === "REFUND") {
//               return "bg-yellow-100"; // 🟡 Darker Refund
//             }

//             if (
//               row.txnType === "CREDIT" ||
//               row.txnType === "APPROVED"
//             ) {
//               return "bg-green-100"; // 🟢 Darker Credit
//             }

//             if (row.txnType === "REJECTED") {
//               return "bg-red-200 border-l-4 border-red-600"; // 🔴 More strong rejected
//             }

//             return "";
//           }}
//           footerTotals={{
//             totalCR,
//             totalDR,
//             totalNetAmount,
//             totalCharges,
//             totalTds,
//             totalCommission,
//           }}
//         />

//         {/* ================= LOAD MORE ================= */}
//         {page + 1 < totalPages && (
//           <div className="flex justify-center mt-6">
//             <button
//               onClick={handleLoadMore}
//               disabled={loading}
//               className="px-8 py-3 rounded-xl bg-gray-900 text-white font-semibold hover:bg-gray-800"
//             >
//               {loading ? "Loading..." : "Load Next Transactions"}
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );

// };

// export default LedgerReport;





import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import useApi from "../../../CustomHooks/useApi";
import DynamicTable from "../../../ResuableCompoment/DynamicTable";
import { getDisplayDate } from "../../../ResuableCompoment/GetDisplayDate";
import FullScreenLoader from "../../LoaderCustom.js"
import { 
  FileSpreadsheet, 
  Search, 
  Calendar, 
  ArrowRight, 
  Layers, 
  ChevronRight, 
  Sparkles,
  RotateCw
} from "lucide-react";

/* ================= HELPERS ================= */
const getToday = () => {
  const date = new Date();
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const FILTER_BUTTONS = [
  { label: "Account Statement", value: "ACCOUNT" },
  { label: "DMT", value: "DMT" },
  { label: "AEPS", value: "AEPS" },
  { label: "PPI", value: "PPI" },
  { label: "CMS", value: "CMS" },
  { label: "SETTLEMENT", value: "SETTLEMENT" },
  { label: "RECHARGE", value: "RECHARGE" },
  { label: "CREDIT CARD BILL", value: "CCBP" },
  { label: "FUND (CR / DR)", value: "BZCIN" },
  { label: "BENE VERIFY", value: "BENE" },
  { label: "FUND REQUEST", value: "FUND_REQUEST" },
  { label: "PG", value: "PG" },
  { label: "SUBSCRIPTION", value: "SUBSCRIPTION" },
  { label: "OVER DRAFT", value: "OD" },
  { label: "REFUND", value: "REFUND" },
];

/* ================= COLUMNS ================= */
const columns = [
  {
    key: "txnId",
    label: "Txn ID",
  },
  {
    key: "txnDate",
    label: "Date",
    render: (v) => getDisplayDate(v),
  },
  {
    key: "narration",
    label: "Narration",
    render: (v) => (
      <span className="text-indigo-700 font-medium">
        {v || "—"}
      </span>
    ),
  },
  {
    key: "amount_cr",
    label: "Amount (CR)",
    render: (_, row) => {
      if (row.txnType === "REJECTED") {
        return (
          <span className="font-semibold text-rose-600">
            ₹{Number(row.netAmount || 0).toFixed(2)}
          </span>
        );
      }

      if (row.txnType === "CREDIT" || row.txnType === "APPROVED" || row.txnType === "REFUND") {
        return (
          <span className="font-semibold text-emerald-700">
            ₹{Number(row.netAmount || 0).toFixed(2)}
          </span>
        );
      }

      return <span className="text-slate-400">—</span>;
    },
  },
  {
    key: "amount_dr",
    label: "Amount (DR)",
    render: (_, row) =>
      (row.txnType === "DEBIT" || row.txnType === "REVERSED") ? (
        <span className="font-semibold text-rose-600">
          ₹{Number(row.netAmount || 0).toFixed(2)}
        </span>
      ) : (
        <span className="text-slate-400">—</span>
      ),
  },
  {
    key: "charges",
    label: "Charge",
    render: (v) => (
      <span className="font-semibold text-rose-700">
        ₹{Number(v || 0).toFixed(2)}
      </span>
    ),
  },
  {
    key: "tds",
    label: "TDS",
    render: (v) => (
      <span className="font-semibold text-rose-800">
        ₹{Number(v || 0).toFixed(2)}
      </span>
    ),
  },
  {
    key: "txnAmount",
    label: "Net Amount",
    render: (v, row) => {
      const value = Number(v || 0);
      if (!row || !value) return <span className="text-slate-400">—</span>;
      if (row.txnType === "CREDIT" || row.txnType === "APPROVED" || row.txnType === "REJECTED" || row.txnType === "REFUND") {
        return (
          <span className="font-semibold text-emerald-700">
            ₹{value.toFixed(2)}
          </span>
        );
      }

      if (row.txnType === "DEBIT" || row.txnType === "REVERSED") {
        return (
          <span className="font-semibold text-rose-600">
            ₹{value.toFixed(2)}
          </span>
        );
      }

      return <span className="text-slate-400">—</span>;
    },
  },
  {
    key: "commission",
    label: "Comm",
    render: (_, row) => {
      const value = Number(row.cashback || row.commission || 0);
      return (
        <span className="font-bold text-emerald-800">
          ₹{value.toFixed(2)}
        </span>
      );
    },
  },
  {
    key: "balance",
    label: "Balance",
    render: (v) => (
      <span className="font-semibold text-blue-900">
        ₹{Number(v || 0).toFixed(2)}
      </span>
    ),
  },
];

const HIDDEN_LEDGER_TABS = new Set(["DMT", "AEPS", "SETTLEMENT", "PPI"]);

const LedgerReport = () => {
  const mid = useSelector(state => state.auth.employeeDetails?.username);
  const role = useSelector(state => state.auth.employeeDetails?.role);
  const hideRestricted = mid === "sou4276_2330" && role === "MERCHANT";
  const { callApi: ledgerreport } = useApi("/ledger/retailer", "GET");

  /* ================= STATES ================= */
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [page, setPage] = useState(0);
  const [size, setSize] = useState(25);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [goToPage, setGoToPage] = useState("");
  const [filterType, setFilterType] = useState("ACCOUNT");

  /* ================= FETCH LEDGER ================= */
  const fetchLedger = async (
    targetPage = 0,
    loadMore = false,
    fDate = fromDate,
    tDate = toDate,
    fType = filterType,
    isInitial = false
  ) => {
    setLoading(true);

    let query = `?bid=${mid}&page=${targetPage}&size=${size}`;
    if (fDate) query += `&fromDate=${fDate}`;
    if (tDate) query += `&toDate=${tDate}`;

    if (fType && fType !== "ACCOUNT") {
      query += `&feature=${fType}`;
    }

    try {
      const res = await ledgerreport(null, query);
      const data = (res?.content || []).filter(Boolean);

      setTotalPages(res?.totalPages || 0);
      setTotalElements(res?.totalElements || 0);

      setHistory(prev =>
        loadMore ? [...prev, ...data] : data
      );

      setPage(targetPage);
    } catch (err) {
      console.error(err);
      if (!loadMore) setHistory([]);
    } finally {
      setLoading(false);
      if (isInitial || isInitialLoading) {
        setIsInitialLoading(false);
      }
    }
  };

  /* ================= INITIAL LOAD ================= */
  useEffect(() => {
    const today = getToday();
    setFromDate(today);
    setToDate(today);
    fetchLedger(0, false, today, today, "ACCOUNT", true);
    // eslint-disable-next-line
  }, []);

  /* ================= PAGE SIZE CHANGE ================= */
  useEffect(() => {
    if (fromDate && toDate) {
      fetchLedger(0, false, fromDate, toDate);
    }
    // eslint-disable-next-line
  }, [size]);

  /* ================= SEARCH & FILTERS ================= */
  const handleSearch = () => {
    fetchLedger(0, false, fromDate, toDate, filterType);
  };

  const handleFilterClick = (type) => {
    setFilterType(type);
    setHistory([]);
    setPage(0);
    fetchLedger(0, false, fromDate, toDate, type);
  };

  /* ================= PAGINATION ACTIONS ================= */
  // const handleGoToPage = () => {
  //   const p = Number(goToPage);
  //   if (p < 1 || p > totalPages) {
  //     alert(`Enter page between 1 and ${totalPages}`);
  //     return;
  //   }
  //   fetchLedger(p - 1, false, fromDate, toDate);
  // };

  /* ================= PAGINATION ACTIONS ================= */
  const handleGoToPage = () => {
    const p = Number(goToPage);
    if (p < 1 || p > totalPages) {
      alert(`Enter page between 1 and ${totalPages}`);
      return;
    }
    fetchLedger(p - 1, false, fromDate, toDate); // false means replace data instead of append
  };

  // 🔥 1. New function to handle page changes
  const handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      fetchLedger(newPage, false, fromDate, toDate); // false = replace data
      
      // Optional: Scroll to top of table when page changes
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // 🔥 2. Helper to generate page numbers with ellipses (e.g., 1 2 3 ... 10)
  const getPaginationPages = (current, total) => {
    if (total <= 1) return [];
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const pages = [];
    const delta = 2;
    let prev = null;
    for (let i = 1; i <= total; i++) {
      if (i === 1 || i === total || (i >= current + 1 - delta && i <= current + 1 + delta)) {
        if (prev !== null && i - prev > 1) pages.push("...");
        pages.push(i);
        prev = i;
      }
    }
    return pages;
  };

  const handleLoadMore = () => {
    if (page + 1 < totalPages) {
      fetchLedger(page + 1, true, fromDate, toDate);
    }
  };

  /* ================= EXCEL DOWNLOAD ================= */
  const downloadExcel = async () => {
    setLoading(true);

    let allData = [];
    let currentPage = 0;
    const excelSize = 1000;

    try {
      while (true) {
        let query = `?bid=${mid}&page=${currentPage}&size=${excelSize}`;
        if (fromDate) query += `&fromDate=${fromDate}`;
        if (toDate) query += `&toDate=${toDate}`;

        if (filterType && filterType !== "ACCOUNT") {
          query += `&feature=${filterType}`;
        }

        const res = await ledgerreport(null, query);
        const pageData = (res?.content || []).filter(Boolean);
        allData = [...allData, ...pageData];

        if (currentPage + 1 >= (res?.totalPages || 0)) break;
        currentPage++;
      }

      if (allData.length === 0) {
        alert("No data found for Excel");
        return;
      }

      const rows = allData.map(r => ({
        Date: getDisplayDate(r.txnDate),
        TxnID: r.txnId,
        Shop: r.shopName,
        Narration: r.narration,
        Type: r.txnType,
        Credit:
          r.txnType === "CREDIT" || r.txnType === "APPROVED" || r.txnType === "REJECTED"
            ? r.txnAmount
            : "",
        Debit:
          r.txnType === "DEBIT" || r.txnType === "REVERSED"
            ? r.netAmount
            : "",
        Refund:
          r.txnType === "REFUND"
            ? r.txnAmount
            : "",
        Charge: r.charges,
        Cashback: r.cashback,
        Commission: r.commission,
        TDS: r.tds,
        Balance: r.balance,
      }));

      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Ledger");
      XLSX.writeFile(wb, `Ledger_${filterType}_${fromDate}_to_${toDate}.xlsx`);
    } catch (err) {
      console.error(err);
      alert("Excel download failed");
    } finally {
      setLoading(false);
    }
  };

  /* ================= TOTAL CALCULATIONS ================= */
  const totalCR = history.reduce(
    (sum, tx) =>
      (tx?.txnType === "CREDIT" || tx?.txnType === "APPROVED" || tx.txnType === "REJECTED")
        ? sum + Number(tx?.netAmount || 0)
        : sum,
    0
  );

  const totalDR = history.reduce(
    (sum, tx) =>
      (tx?.txnType === "DEBIT" || tx.txnType === "REVERSED")
        ? sum + Number(tx?.netAmount || 0)
        : sum,
    0
  );

  const totalNetAmount = history.reduce(
    (sum, tx) => sum + Number(tx?.txnAmount || 0),
    0
  );

  const totalCharges = history.reduce(
    (sum, tx) => sum + Number(tx?.charges || 0),
    0
  );

  const totalTds = history.reduce(
    (sum, tx) => sum + Number(tx?.tds || 0),
    0
  );

  const totalCommission = history.reduce(
    (sum, tx) => sum + Number(tx?.commission || 0),
    0
  );


  

  return (
    <div className="min-h-screen bg-[#F8FAFC] p-4 sm:p-6 lg:p-8 space-y-6">
      
      {/* FULL SCREEN INITIAL LOADER */}
      {isInitialLoading && (
        <FullScreenLoader 
          message="Loading Ledger Records..." 
        />
      )}

      {/* ================= PAGE HEADER ================= */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100 mb-2">
            <Layers className="w-3.5 h-3.5" />
            Financial Ledger & Statements
          </div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-800 tracking-tight">
            Ledger Report
          </h1>
          <p className="text-xs sm:text-sm text-slate-500 font-medium mt-0.5">
            Complete transaction history, credit/debit breakdowns, and balance audits
          </p>
        </div>
      </div>

      {/* ================= MODERN SERVICE FILTER PILLS ================= */}
      {/* <div className="bg-white rounded-3xl p-3 sm:p-4 border border-slate-200/80 shadow-xs">
        <div className="flex items-center gap-2 overflow-x-auto pb-1 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          {FILTER_BUTTONS.filter(btn => !(hideRestricted && HIDDEN_LEDGER_TABS.has(btn.value))).map(btn => {
            const isActive = filterType === btn.value;
            return (
              <button
                key={btn.value}
                onClick={() => handleFilterClick(btn.value)}
                className={`
                  px-4 py-2 rounded-xl text-xs font-bold whitespace-nowrap transition-all duration-200 active:scale-95 cursor-pointer
                  ${isActive
                    ? "bg-slate-900 text-white shadow-md shadow-slate-900/10 border border-slate-900"
                    : "bg-slate-50 hover:bg-slate-100 text-slate-600 border border-slate-200/70"
                  }
                `}
              >
                {btn.label}
              </button>
            );
          })}
        </div>
      </div> */}
      <div className="bg-white rounded-3xl p-3 sm:p-4 border border-slate-200/80 shadow-xs">
  {/* Changed: Removed overflow and scrollbar hiding classes, added flex-wrap */}
  <div className="flex flex-wrap items-center gap-2">
    {FILTER_BUTTONS.filter(btn => !(hideRestricted && HIDDEN_LEDGER_TABS.has(btn.value))).map(btn => {
      const isActive = filterType === btn.value;
      return (
        <button
          key={btn.value}
          onClick={() => handleFilterClick(btn.value)}
          className={`
            px-4 py-2 rounded-xl text-xs font-bold whitespace-nowrap transition-all duration-200 active:scale-95 cursor-pointer
            ${isActive
              ? "bg-slate-900 text-white shadow-md shadow-slate-900/10 border border-slate-900"
              : "bg-slate-50 hover:bg-slate-100 text-slate-600 border border-slate-200/70"
            }
          `}
        >
          {btn.label}
        </button>
      );
    })}
  </div>
</div>

      {/* ================= FILTER & DATE SELECTION BAR ================= */}
      <div className="bg-white rounded-3xl p-5 sm:p-6 border border-slate-200/80 shadow-xs space-y-5">
        <div className="flex flex-wrap items-end justify-between gap-4">
          
          {/* Date Picker Group */}
          <div className="flex flex-wrap items-center gap-3 sm:gap-4">
            <div className="space-y-1.5">
              <label className="text-[11px] font-bold uppercase tracking-wider text-slate-500">From Date</label>
              <div className="relative">
                <input
                  type="date"
                  value={fromDate}
                  onChange={e => setFromDate(e.target.value)}
                  className="h-10 px-3.5 bg-slate-50 border border-slate-200/80 focus:border-blue-500 focus:bg-white rounded-xl text-xs font-semibold text-slate-700 outline-hidden transition"
                />
              </div>
            </div>

            <div className="space-y-1.5">
              <label className="text-[11px] font-bold uppercase tracking-wider text-slate-500">To Date</label>
              <div className="relative">
                <input
                  type="date"
                  value={toDate}
                  onChange={e => setToDate(e.target.value)}
                  className="h-10 px-3.5 bg-slate-50 border border-slate-200/80 focus:border-blue-500 focus:bg-white rounded-xl text-xs font-semibold text-slate-700 outline-hidden transition"
                />
              </div>
            </div>

            <div className="flex items-center gap-2 pt-5">
              <button
                onClick={handleSearch}
                className="h-10 px-5 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-bold text-xs shadow-md shadow-blue-500/20 transition active:scale-95 flex items-center gap-2"
              >
                <Search className="w-3.5 h-3.5" />
                <span>Search</span>
              </button>

              <button
                onClick={downloadExcel}
                disabled={loading}
                className="h-10 px-5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs shadow-md shadow-emerald-600/20 transition active:scale-95 flex items-center gap-2 disabled:opacity-50 cursor-pointer"
              >
                <FileSpreadsheet className="w-3.5 h-3.5" />
                <span>{loading ? "Exporting..." : "Export Excel"}</span>
              </button>
            </div>
          </div>

          {/* Quick Pagination Tools */}
          <div className="flex flex-wrap items-center gap-3 pt-2 sm:pt-0">
            <div className="flex items-center gap-1.5 text-xs text-slate-500 font-medium">
              <span>Rows per page:</span>
              <select
                value={size}
                onChange={e => setSize(Number(e.target.value))}
                className="h-9 px-2.5 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold text-slate-700 outline-hidden"
              >
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={500}>500</option>
                <option value={1000}>1000</option>
                <option value={2000}>2000</option>
              </select>
            </div>

            <div className="flex items-center gap-1.5">
              <input
                type="number"
                placeholder="Page"
                value={goToPage}
                onChange={e => setGoToPage(e.target.value)}
                className="h-9 w-16 px-2.5 bg-slate-50 border border-slate-200 rounded-xl text-xs font-semibold text-slate-700 outline-hidden text-center"
              />
              <button
                onClick={handleGoToPage}
                className="h-9 px-3.5 rounded-xl bg-slate-900 hover:bg-slate-800 text-white text-xs font-bold transition active:scale-95"
              >
                Go
              </button>
            </div>
          </div>

        </div>

        {/* Ledger Count Badge Bar */}
        <div className="pt-3 border-t border-slate-100 flex flex-wrap items-center justify-between text-xs text-slate-500 font-medium gap-2">
          <div className="flex items-center gap-4">
            <span>Total Records: <strong className="text-slate-800">{totalElements.toLocaleString("en-IN")}</strong></span>
            <span>Total Pages: <strong className="text-slate-800">{totalPages}</strong></span>
          </div>
          <div>
            Current Page: <strong className="text-blue-600 font-bold">{page + 1}</strong> of <strong>{totalPages || 1}</strong>
          </div>
        </div>
      </div>

      {/* ================= LEDGER TABLE CONTAINER ================= */}
      <div className="bg-white rounded-3xl border border-slate-200/80 shadow-xs p-2 sm:p-4">
        <DynamicTable
          columns={columns}
          data={history}
          isLoading={loading}
          emptyText="No ledger records found for this selection"
          rowClassName={(row) => {
            if (row.txnType === "DEBIT" || row.txnType === "REVERSED") {
              return "bg-rose-50/60";
            }
            if (row.txnType === "REFUND") {
              return "bg-amber-50/60";
            }
            if (row.txnType === "CREDIT" || row.txnType === "APPROVED") {
              return "bg-emerald-50/60";
            }
            if (row.txnType === "REJECTED") {
              return "bg-rose-100/70 border-l-4 border-rose-600";
            }
            return "";
          }}
          footerTotals={{
            totalCR,
            totalDR,
            totalNetAmount,
            totalCharges,
            totalTds,
            totalCommission,
          }}
        />

        {/* Load More Button */}
        {/* {page + 1 < totalPages && (
          <div className="flex justify-center pt-6 pb-2">
            <button
              onClick={handleLoadMore}
              disabled={loading}
              className="px-8 py-3 rounded-2xl bg-slate-900 hover:bg-slate-800 text-white text-xs font-bold tracking-wide transition active:scale-98 shadow-sm flex items-center gap-2 cursor-pointer disabled:opacity-50"
            >
              {loading ? (
                <>
                  <RotateCw className="w-3.5 h-3.5 animate-spin" />
                  <span>Fetching Next Records...</span>
                </>
              ) : (
                <>
                  <span>Load Next Page Transactions</span>
                  <ArrowRight className="w-3.5 h-3.5" />
                </>
              )}
            </button>
          </div>
        )} */}

        {/* ================= PAGINATION SYSTEM ================= */}
        {totalPages > 1 && (
          <div className="flex flex-wrap items-center justify-center gap-2 pt-6 pb-2">
            
            {/* Previous Button */}
            <button
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 0 || loading}
              className="h-10 px-4 rounded-xl border border-slate-200 bg-white text-slate-600 font-semibold text-xs transition hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
            >
              Previous
            </button>

            {/* Page Numbers */}
            <div className="flex items-center gap-1.5 hidden sm:flex">
              {getPaginationPages(page, totalPages).map((p, i) =>
                p === "..." ? (
                  <span key={`ellipsis-${i}`} className="w-8 text-center text-slate-400 font-medium">...</span>
                ) : (
                  <button
                    key={p}
                    onClick={() => handlePageChange(p - 1)}
                    disabled={loading}
                    className={`h-10 min-w-[40px] px-2 rounded-xl border text-xs font-bold transition flex items-center justify-center
                      ${page === p - 1
                        ? "bg-slate-900 text-white border-slate-900 shadow-md"
                        : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50 hover:text-slate-900"
                      }`}
                  >
                    {p}
                  </button>
                )
              )}
            </div>

            {/* Next Button */}
            <button
              onClick={() => handlePageChange(page + 1)}
              disabled={page + 1 >= totalPages || loading}
              className="h-10 px-4 rounded-xl border border-slate-200 bg-white text-slate-600 font-semibold text-xs transition hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
            >
              Next
            </button>

          </div>
        )}
      </div>

    </div>
  );
};

export default LedgerReport;